module.exports = __webpack_public_path__ + "img/image-1.9ab99174.jpg";